export default "__VITE_ASSET__Cm6CL3UW__"